module.exports = __webpack_public_path__ + "static/media/floral-design-of-one-flower-lines-and-small-circles-svgrepo-com.d1975971.svg";